// extracted by mini-css-extract-plugin
module.exports = {"post_card_wrapper":"PostCard_post_card_wrapper__3hvRC","title":"PostCard_title__MifRQ","items":"PostCard_items__2X2XC","link":"PostCard_link__h_htt"};